export default "__VITE_ASSET__B38M4d92__"